"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cabStyle = void 0;
const types_1 = require("../../types");
const { CabStyleEnum } = types_1.Vehicle;
exports.cabStyle = [
    {
        id: CabStyleEnum.RegularCab,
        name: 'Regular Cab',
    },
    {
        id: CabStyleEnum.ExtendedCab,
        name: 'Extended Cab',
    },
    {
        id: CabStyleEnum.CrewCab,
        name: 'Crew Cab',
    },
];
